import matchmedia from "matchmedia-ng/matchmedia-ng.js";
export default "matchmedia-ng";



// WEBPACK FOOTER //
// ./src/ui/app/services/matchmedia.js